import {InputBase, inputBaseClasses, styled} from "@mui/material";

const CustomInput = styled(InputBase)(({theme}) => ({
    padding: 12,
    background: theme.palette.background.box,
    borderRadius: 8,
    boxShadow: "0px 0px 12px -1px rgba(33, 33, 33, 0.15)",
    [`& .${inputBaseClasses.input}::placeholder`]: {
        fontSize: ".875rem",
        color: "#616161",
        opacity: .75
    },
    "&.Mui-error": {outline: "2px solid #d32f2f"},
}));
export default CustomInput;